export default {
    CARD: 'CARD',
    SLIDER: 'SLIDER'
}
